import React from 'react'

function JdCreateManual() {
  return (
    <div>JdCreateManual</div>
  )
}

export default JdCreateManual